import React,{useState,useEffect} from "react";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  import { useDispatch,useSelector } from 'react-redux';
import Profile from "../Dashboard/Profile/Profile";
import CRMLogin from "./CRMlogin";
  
import {  Link  } from "react-router-dom";
import { checkLeadManagerLoginStatus } from "../../store/actions/CRM/checkLeadManagerLoginStatus";
import Loading from "../Loading/Loading";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    MessageCircle,
    MessageCircleHeart,
    Share2} from 'lucide-react';
   import { AllLeadState } from "./allLeadStates";
   import { AllLeadMaharashtraCities,AllLeadKarnatakaCities } from "./allLeadCities";
import SelectOptionCard from "./SelectOptionCard";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Snackbar from "../../Snackbar";
import { createALeadByManager } from "../../store/actions/CRM/createALeadByManager";
import { getLeadsBySearchParameter } from "../../store/actions/CRM/getLeadsBySearchParameter";
import LeadLoadingCards from "./LeadLoadingCards";

 const SearchLeads = ({baseUrl})=>{
      const [open , setOpen]=useState(false);
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
   
            const history = useHistory();
     const [snackbarVisible, setSnackbarVisible] = useState(false);
       const [snackbarColor, setSnackbarColor] = useState("#958FDA");
       const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
     
     const showSnackbar = () => {
       setSnackbarVisible(true);
     };
    
     const hideSnackbar = () => {
       setSnackbarVisible(false);
     };
  const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
    {
      
      dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
      dispatch({type: "CURSOR",payload:true  });
  
      dispatch({type: "CURSORTEXT",payload:CursorText})
      dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
      dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
    }
     
    const handleMouseLeave = () => {
      dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
      
      dispatch({type: "CURSOR",payload:false})
  
      dispatch({type: "CURSORTEXT",payload:""})
  
      dispatch({type: "CURSORTEXTBG",payload:""})
      dispatch({type: "CURSORTEXTCOLOR",payload:""})
    
  
  }
   const [loader , setLoader] =useState({status:false});
   
      const [statusData , setStatusData] =useState({status:false});
   const [stateName , setStateName] =useState("Delhi");
   const [cityName , setCityName] =useState("Delhi");
   const [openStatePopUp , setOpenStatePopUp] =useState(false);
   const [openCityPopUp , setOpenCityPopUp] =useState(false);
   
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
   const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 
    const {url,path} =useRouteMatch();
     
     
   const CRMtoken= useSelector((state)=>state?.crmData?.crmPass);
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
      
   const userdata = useSelector((state)=>state?.user?.user);
 const userEmail = useSelector((state)=>state?.user?.user?.user_email);

 const [leadName, setLeadName] = useState("");
 const [leadId, setLeadId] = useState("");
   const [hasWebsite, setHasWebsite] = useState("");
   const [openEditPopUp, setOpenEditPopUp] = useState(false);
   const [openEditPopUpInfo, setOpenEditPopUpInfo] = useState("")
   const [editLeadType, setEditLeadType] = useState("");
   
    const [addedInfo, setAddedInfo] = useState("");
   const [page, setPage] = useState('1');
   const [ leadMobileNo, setLeadMobileNo] = useState("");
   const [ leadRefLink, setLeadRefLink] = useState("");
   const [ leadAddress, setLeadAddress] = useState("");
   const [ leadWhatsAppNo, setLeadWhatsAppNo] = useState("");
   const [ leadEmailId, setLeadEmailId] = useState("");
   const [leadDataArr, setLeadDataArr] = useState("");
   const [timerLeadLoadingCards, setTimerLeadLoadingCards] = useState(true);
     const [leadExtraMemberArr, setLeadExtraMemberArr] = useState("");
   

 function generateTimestamp() {
  return Math.floor(Date.now() / 1000);
}

// const removeLeadExtraMember= (id) => {
//   const filteredLeadExtraMember = leadExtraMemberArr.filter(item => item.id !== id);
//   setLeadExtraMemberArr(filteredLeadExtraMember);
// };
// const updateLeadExtraMemberName = (id, memberName) => {
//   const updatedLeadExtraMember = leadExtraMemberArr.map(item =>
//     item.id === id ? { ...item, memberName :memberName } : item
  
//   ); 
  
//   setLeadExtraMemberArr(updatedLeadExtraMember);
// };
// const updateLeadExtraMemberContactNo= (id, memberContactNo) => {
//   const updatedLeadExtraMember= leadExtraMemberArr.map(item =>
//     item.id === id ? { ...item, contactNo :memberContactNo } : item
  
//   ); 
  
//   setLeadExtraMemberArr(updatedLeadExtraMember);
// };

const leadData = leadDataArr!=[]?Object.values(leadDataArr):'';



     useEffect(() => {
      handleSearchLeads()
       
        },[])
const handleSearchLeads=(e)=>{

setTimerLeadLoadingCards(true);

setLoader({status:true});
let filter=""; ;
if(leadMobileNo!==""){
    filter ="byMobileNo";
}
  const user = dispatch(getLeadsBySearchParameter({
    leadState:stateName,leadCity:cityName,leadName:leadName,leadMobileNo:leadMobileNo,
    leadRefLink:leadRefLink,leadAddress:leadAddress,leadWhatsAppNo:leadWhatsAppNo,leadEmailId:leadEmailId,
    
    leadId:"",page:page,
    userEmail:userEmail,
    currentToken:currentToken,CRMtoken:CRMtoken,appToken:AppToken,
    filter:filter}));
  /* get response as Promise   */
  user.then(response => {
    if(response){
    setResponseMessage(response?.message);
    setSnackbarColor(response?.color);
    setLeadDataArr(response?.leads); setCurrentPage(1)
    setTimeout(()=>{
    setTimerLeadLoadingCards(false);
    },500);
 
   if(response?.logout){
    
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});
      history.push(`/dashboard/`)
    },3000);
    
  }
/* resetting Login input Fields */

setLoader({status:false});

setSnackbarVisible(true);

setTimeout(()=>{
 
  
  setSnackbarVisible(false);

},1000)
    }else{
    
setLoader({status:false});

setSnackbarVisible(true);
      setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
setLoader({status:false});
    console.error(error);
  });
 
  }
const handleEditLead=(leadId,editType)=>{



setLoader({status:true});
  const user = dispatch(createALeadByManager({
    leadState:stateName,leadCity:cityName,leadName:leadName,hasWebsite:hasWebsite
    ,addedInfo:addedInfo,leadMobileNo:leadMobileNo,
    leadRefLink:leadRefLink,leadAddress:leadAddress,leadWhatsAppNo:leadWhatsAppNo,
    leadEmailId:leadEmailId,
    leadExtraMembers:JSON.stringify(leadExtraMemberArr),
    leadId:leadId,
    userEmail:userEmail,
    currentToken:currentToken,CRMtoken:CRMtoken,appToken:AppToken,
    editType:editType}));
  /* get response as Promise   */
  user.then(response => {
    if(response){
    setResponseMessage(response?.message);
    setSnackbarColor(response?.color);
 console.log(response)
   const itemIndex = currentItems.findIndex((item) => item.leadId === leadId);
   if (itemIndex !== -1) {
    if(editType=='editleadName'){
      currentItems[itemIndex].leadName = response;  // Mutating the array
    }
   else if(editType=='editleadAddress'){
      currentItems[itemIndex].leadAddress = response;  // Mutating the array
    }
   
     
   }
   setOpenEditPopUp(false);
  
setLoader({status:false});

setSnackbarVisible(true);

setTimeout(()=>{
 
  
  setSnackbarVisible(false);
 
},1000)
    }else{
    
setLoader({status:false});

setSnackbarVisible(true);
      setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong!!!");
    setSnackbarColor("rgb(218, 143, 143) ");
setLoader({status:false});

    console.error(error);
  });
 
  }

  useEffect(() => {
     setOpen(false) 
  setLoader({status:true});
  const LeadManagerLoginStatusData= {userEmail:userdata?.user_email,CRMtoken:CRMtoken,currentToken:currentToken}
     const user = dispatch(checkLeadManagerLoginStatus(LeadManagerLoginStatusData));
     /* get response as Promise   */
     user.then(response => {
     // pop up with message 
     //   console.log(response)
     setStatusData(response)
 
     if(response?.crmAccessStatus=='yes'){}else{ history.push(`${baseUrl}/crm-login`);}
    
      setInterval(()=>{
       // hide poped message 
       
      },3000)
      
  
   
   setLoader({status:false});
   
   
   
     }).catch(error => {
       
   /* resetting Login input Fields */
   //setLogin({user_email:'',user_pass:""
   
   // })
   setLoader({status:false});
       console.error(error);
     });
    
 
 
 
   }, []);
  
   
 // State variables
 const [currentPage, setCurrentPage] = useState(1);
 const itemsPerPage = 10;

 // Calculate total pages
 const totalPages = Math.ceil(leadData.length / itemsPerPage);
    
 // Get items for the current page
 const currentItems = leadData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

 // Handle page change
 const goToPage = (page) => {
   if (page >= 1 && page <= totalPages) {
     setCurrentPage(page);
     setTimerLeadLoadingCards(true);
     setTimeout(()=>{
      setTimerLeadLoadingCards(false);
      },500);
     window.scrollTo({
        top: 0,
        behavior: "smooth", // Smooth scrolling
      });
   }
 };

    return <>
    {/* {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )} */}
{statusData?.crmAccessStatus=='yes'?
<div>
    <div className="outer-right">
       

    
<div className="outer-profile  " >
<div className="outer-profile-in " style={{background:"#fff",padding:"0px",marginTop:"5px",marginBottom:"5px"}}>
<div className="outer-profile-subvals outer-profile-title ">
    {"Hey "+(userdata?.first_name?userdata?.first_name:" There! ")+" Welcome to  classmock.com" }</div>
   
<div >

<div  className=" outer-profile-in" style={{background:"#f1f1f1",padding:"0px",marginTop:"5px",marginBottom:"5px"}} >
<div >



 <div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
 <div className="dashboardGridBtns"><div className="dashboardGridBtns">
    <div  className="crm-button-two"  style={{cursor:"pointer"}} onClick={()=>{setOpenStatePopUp(true)}} onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","Click To Change State")}
onMouseLeave={handleMouseLeave}>{stateName}</div> 
 <div className="crm-button-two" style={{cursor:"pointer"}}  onClick={()=>{setOpenCityPopUp(true)}}
onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","Click To Change City")}
onMouseLeave={handleMouseLeave} >{cityName}</div> 
 </div></div>
<div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
  <div align="right">

  <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="crm-button-two" 
      style= {{fontSize:"18px",textAlign:"left"}} placeholder="Search by Mobile No"  type="text"
  name="leadMobileNo" value={leadMobileNo}
  onChange={(e)=>setLeadMobileNo(e.target.value)}  />
  </div><div align="right">
<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={handleSearchLeads}  style={{width:"140px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn">Search</button>

  
</div>
</div>
        </div>
       
        {timerLeadLoadingCards?<><LeadLoadingCards/><LeadLoadingCards/><LeadLoadingCards/></>:
        currentItems!=""&&currentItems!=undefined?Object.values(currentItems).map((item, index) => 
        (item?<div className="leadSearchItemOuter"  index={index} key={index} >
<div>
<div className="leadCardLeftBox">
<div  className="leadCircleBtn"  style={{cursor:"pointer"}}
 onClick={()=>{}} onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","Send SMS")}
onMouseLeave={handleMouseLeave}>
    <MessageCircle/></div> 
    <div  className="leadCircleBtn"  style={{cursor:"pointer"}}
 onClick={()=>{}} onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","Send Whatsapp")}
onMouseLeave={handleMouseLeave}>
   <MessageCircleHeart/></div>
    <div  className="leadCircleBtn"  style={{cursor:"pointer"}}
 onClick={()=>{}} onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","Send Email")}
onMouseLeave={handleMouseLeave}>
    <Share2/> </div>
</div><div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
{item?.hasWebsite?<a href={`${item?.hasWebsite}`} target="_blank" rel="noopener noreferrer">

<div className="crm-button-one" style={{cursor:"pointer"}}  
onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","This Is Leads Already Created Website")}
onMouseLeave={handleMouseLeave} >Website</div>

</a> :""} {item?.leadRefLink?<a href={`${item?.leadRefLink}`} target="_blank" rel="noopener noreferrer">

<div className="crm-button-three" style={{cursor:"pointer"}}  
onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","This Is Leads Reference Link From Where His Data is Collected")}
onMouseLeave={handleMouseLeave} >Ref Link</div>

</a> :""}</div></div>
<div className="dashboardGridBtns"style={{padding:"0px",margin:"0px"}} >
   <div>
    {item?.leadName?<h2  style={{cursor:"pointer"}}
      onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","Edit Lead Name")}
onMouseLeave={handleMouseLeave}
onClick={()=>{setOpenEditPopUp(true);setEditLeadType('editleadName');
setOpenEditPopUpInfo("Lead Institute Or Person Name");setLeadName(item?.leadName);setLeadId(item?.leadId)}} 
>{item?.leadName}</h2>:<h2  style={{cursor:"pointer"}}
      onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","Edit Lead Name")}
onMouseLeave={handleMouseLeave}
onClick={()=>{setOpenEditPopUp(true);setEditLeadType('editleadName');setOpenEditPopUpInfo("Lead Institute Or Person Name");setLeadName(item?.leadName);setLeadId(item?.leadId)}} 
>Edit Lead Name</h2>}
   
    {item?.leadAddress?<h4  style={{cursor:"pointer"}}
      onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","Edit Lead Address")}
onMouseLeave={handleMouseLeave}
onClick={()=>{setOpenEditPopUp(true);setEditLeadType('editLeadAddress');
setOpenEditPopUpInfo("Edit Lead Address");setLeadAddress(item?.leadAddress);setLeadId(item?.leadId)}} 
>{item?.leadAddress}</h4>:<h4  style={{cursor:"pointer"}}
      onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","Edit Lead Address")}
onMouseLeave={handleMouseLeave}
onClick={()=>{setOpenEditPopUp(true);setEditLeadType('editLeadAddress')
;setOpenEditPopUpInfo("Edit Lead Address");setLeadAddress(item?.leadAddress);setLeadId(item?.leadId)}} 
>Edit Lead Address</h4>} 
    
<div className="dashboardGridBtns">
    {item?.leadMobileNo?<div  className="crm-button-two" 
     style={{cursor:"pointer"}}  onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","This Is Leads Mobile Number")}
onMouseLeave={handleMouseLeave}>{item?.leadMobileNo}</div> :""}
 {item?.leadWhatsAppNo?<div className="crm-button-two" style={{cursor:"pointer"}}  
onMouseEnter={
    ()=>handleMouseEnter("#99cc99)","#fff","","This Is Leads WhatsApp No")}
onMouseLeave={handleMouseLeave} >{item?.leadWhatsAppNo}</div> :""}


 </div>
 
</div> {
item?.addedInfo?
<div  className=""style={{background:"#f8f8f8",padding:"10px"}}>


<div style={{padding:"0px"}}className="">

<h4 class="">{item?.addedInfo} </h4></div>
</div>:""}
</div>
</div>:<LeadLoadingCards/>) ) :timerLeadLoadingCards?"":<div  className=""style={{background:"#f8f8f8",padding:"10px"}}>


<div style={{padding:"0px"}}className="">

<h3 class="">{"No Lead Data Found"} </h3></div>
</div>
}

<div className="leadFlexTwo"style={{padding:"0px",margin:"0px"}} >
  <div align="right">
  <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={() => goToPage(currentPage - 1)}
     disabled={currentPage === 1} style={{width:"140px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn">Prev</button>
  {currentPage > 1 && (
    <button onClick={() => goToPage(1)}  className="crm-button-one"  
    style={{ marginRight: "5px" , cursor: "pointer",width:"85px",height:"55px"}}>
      First
    </button>
  )}
  </div><div>

  {Array.from(
    { length: totalPages },
    (_, i) => i + 1
  )
    .filter((page) => {
      const halfVisible = Math.floor(5 / 2);
      const startPage = Math.max(1, currentPage - halfVisible);
      const endPage = Math.min(totalPages, currentPage + halfVisible);
      return page >= startPage && page <= endPage;
    })
    .map((page) => (
      <button
        key={page}
        onClick={() => goToPage(page)}
        className={currentPage === page ? "crm-button-one" :"crm-button-two"}
        style={{
          margin: "0 5px",
          padding: "5px 10px",
          fontWeight: currentPage === page ? "bold" : "normal",
          
          color: currentPage === page ? "white" : "black",
          cursor: "pointer", width:"55px",height:"55px"
        }}
      >
        {page}
      </button>
    ))}
  
</div>

 
<div align="right">{currentPage < totalPages && (
    <button   className="crm-button-one"  onClick={() => goToPage(totalPages)} 
    style={{ marginLeft: "5px" ,cursor: "pointer",width:"85px",height:"55px" }}>
      Last
    </button>
  )}
<button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages} style={{width:"140px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn">Next</button>

  
</div>
</div>  </div>
     </div>
 </div>
 </div>
          
        
	  


        
    
    
    
     </div>
    <div>
    
    <div>
      </div>
      </div>
     </div>
     {openStatePopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:999999}} onClick={()=>{setOpenStatePopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div align="center" className="outer-profile-title ">Select A State/UT</div>
        <div  className= "input-card-radio-two "   
>  
{AllLeadState.map((f)=>
        
<SelectOptionCard name={stateName} title={f.stateName}  
   setName={(val)=>{setStateName(val);setCityName(f.mainCity)}} 
   setOpenPopUp={(val)=>setOpenStatePopUp(val)}  />)
 }
  </div>
        </div> </div>:""
        }
            

            
          {openEditPopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:999999}} onClick={()=>{setOpenEditPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div align="center" className="outer-profile-title ">{openEditPopUpInfo}</div> 
        <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadNameInputOne" 
      style= {{fontSize:"18px",}} placeholder={openEditPopUpInfo} type="text"
  rows={2} name="LeadItem" value={editLeadType=="editleadName"?leadName:
  editLeadType=="editLeadAddress"?leadAddress:""}
   onChange={editLeadType=="editleadName"?(e)=>setLeadName(e.target.value)
   :editLeadType=="editLeadAddress"?(e)=>setLeadAddress(e.target.value):{}} />
   
 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     onClick={()=>handleEditLead(leadId,editLeadType)} style={{width:"140px",height:"55px"}} 
     className="crm-button-one"  type="submit"
     id="signupBtn"> {loader?.status?"Updating  ... ":"Update"} </button>
        </div> </div>:""
        }
       
       
       
             {openCityPopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999} }>
   
  
   <div  className="selectThumbImgOuter " style={{margin:'0px',overflowY: "auto",zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",right:"10px",margin:"10px",position:"absolute",
      background:"#958FDA",zIndex:999999}} onClick={()=>{setOpenCityPopUp(false)}}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
       
<div align="center" className="outer-profile-title ">Select A City In {stateName}</div>
        <div  className= "input-card-radio-two "   
>  
{stateName=="Maharashtra"?AllLeadMaharashtraCities.map((f)=>
            
<SelectOptionCard name={cityName} title={f.cityName}  
   setName={(val)=>setCityName(val)} 
   setOpenPopUp={(val)=>setOpenCityPopUp(val)}  />):
   stateName=="Karnataka"?AllLeadKarnatakaCities.map((f)=>
            
    <SelectOptionCard name={cityName} title={f.cityName}  
       setName={(val)=>setCityName(val)} 
       setOpenPopUp={(val)=>setOpenCityPopUp(val)}  />) :""
 }
  </div>
        </div> </div>:""
        }

</div>
:""
}
   
    </>

}
export default SearchLeads;
